<template>
  <button 
    class="custom-button tariff-button" 
    @click="openLink"
  >
    <span>Tariff Details</span>
  </button>
</template>

<script>
export default {
  name: 'TariffAnalysisLink',
  props: {
    plantId: {
      type: [String, Number],
      default: null
    },
    alias: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    retailerId: {
      type: Number,
      default: null
    }
  },
  methods: {
    openLink() {
      // Direct redirect to tariff analysis page
      if (process.env.NODE_ENV === 'production') {
        window.open('https://ai.redxvpp.com/rd/tariff', '_blank');
      } else {
        // Use production URL for both dev and prod since it's an external tool
        window.open('https://ai.redxvpp.com/rd/tariff', '_blank');
      }
    }
  }
}
</script>

<style scoped>
.custom-button {
  cursor: pointer;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: none;
  border-radius: 5px;
  font-size: 0.75rem;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.custom-button:hover {
  box-shadow: 0 2px 6px rgba(60,64,67,0.25);
  background: var(--custom-color1);
  color: white;
  transform: translateY(-1px);
}

.custom-button:active {
  transform: translateY(0);
}

.button-icon {
  width: 16px;
  height: 16px;
}

.tariff-button {
  white-space: nowrap;
}
</style>

